import React from "react";
import cls from "classnames";
import "./styles.scss";
import { ReactComponent as RightArrow } from "logic/src/components/icons/rightLongArrow.svg";
import LinkLogo from "logic/src/components/icons/linkLogo.svg";
import { sendCLK } from "logic/src/utils/eventTrack";

interface ReferencePopoverProps {
  title?: string;
  content?: string;
  url?: string;
  icon?: string;
  domain?: string;
  className?: string;
  index?: string;
}

const ReferencePopover: React.FC<ReferencePopoverProps> = ({
  title,
  content,
  url,
  // icon,
  domain,
  className,
  index,
}) => {
  return (
    <div
      className={cls("reference-popover", index && "clickable", className)}
      onClick={() => {
        sendCLK("text_chat_web_search", "文本聊天_联网资料点击");
        index && url ? window.open(url, "_blank") : undefined;
      }}
    >
      {title && <div className="reference-popover-title">{title}</div>}
      {content && <div className="reference-popover-content">{content}</div>}

      <div className="reference-popover-footer">
        <span className="reference-popover-footer-left">
          <img src={LinkLogo} alt={domain} className="reference-popover-icon" />
          <span className="reference-popover-domain">{domain}</span>
        </span>
        {index ? (
          <span className="sensechat-ref-inner">{index}</span>
        ) : url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="reference-popover-link"
          >
            <RightArrow className="reference-popover-arrow" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ReferencePopover;
